// extracted by mini-css-extract-plugin
export default {"sign-up":"sign-up_sign-up__fvNPI","default":"sign-up_default__0FbwJ","variants":"sign-up_variants__IpyvR","header":"sign-up_header__YqxBT","description":"sign-up_description__D75x5"};